/**
 * Performance Optimized JavaScript
 * Replaces heavy inline scripts with efficient, optimized code
 */

// Slideshow LCP optimization
function optimizeSlideshowLCP() {
  // Prioritize first slide image loading
  const firstSlideImage = document.querySelector('.slideshow__image');
  if (firstSlideImage) {
    // Ensure first image has highest priority
    firstSlideImage.setAttribute('fetchpriority', 'high');
    firstSlideImage.setAttribute('loading', 'eager');
    
    // Add decoding hint for faster rendering
    firstSlideImage.setAttribute('decoding', 'sync');
    
    // Preload next slide image for smoother transitions
    const nextSlideImage = document.querySelector('.slideshow__slide:nth-child(2) .slideshow__image');
    if (nextSlideImage) {
      nextSlideImage.setAttribute('fetchpriority', 'low');
      nextSlideImage.setAttribute('decoding', 'async');
    }
  }
  
  // Optimize slideshow container for better rendering
  const slideshow = document.querySelector('.slideshow');
  if (slideshow) {
    slideshow.style.contain = 'layout style paint';
    slideshow.style.contentVisibility = 'auto';
    slideshow.style.willChange = 'transform';
  }
  
  // Optimize image loading with intersection observer
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      }
    });
  }, { rootMargin: '50px' });
  
  // Observe lazy-loaded images
  document.querySelectorAll('.slideshow__image[loading="lazy"]').forEach(img => {
    imageObserver.observe(img);
  });
}

// Collection list LCP optimization
function optimizeCollectionListLCP() {
  // Prioritize first few collection images
  const collectionImages = document.querySelectorAll('.list-collections__item-image');
  collectionImages.forEach((img, index) => {
    if (index === 0) {
      // First image gets highest priority
      img.setAttribute('fetchpriority', 'high');
      img.setAttribute('loading', 'eager');
    } else if (index < 3) {
      // Next two images get low priority but eager loading
      img.setAttribute('fetchpriority', 'low');
      img.setAttribute('loading', 'eager');
    }
    // Rest keep lazy loading (default)
  });
  
  // Optimize collection list container
  const collectionList = document.querySelector('.list-collections');
  if (collectionList) {
    collectionList.style.contain = 'layout style paint';
  }
}

// Optimized checkout counter - no setInterval, single execution
function initOptimizedCheckoutCounter() {
  const checkoutElement = document.getElementById('checkout-message');
  if (checkoutElement) {
    const initialCount = Math.floor(Math.random() * 6) + 1;
    checkoutElement.innerHTML = '<strong class="changing-number">' + initialCount + '</strong> people are checking out right now';
  }
}

// Optimized Yotpo reviews with debounced observer
function initOptimizedYotpoReviews() {
  let observerTimeout;
  const observer = new MutationObserver((mutations, obs) => {
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(() => {
      const el = document.querySelector('.yotpo-reviews-list');
      if (el) {
        console.log('Element is now in the DOM');
        verifyReview(el);
        obs.disconnect(); // stop observing
      }
    }, 100); // Debounce for better performance
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function verifyReview(el) {   
    const childHTML = `<div class="yotpo-verified-icon-wrapper">
      <svg width="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="yotpo-verified-icon">
        <circle cx="7.5" cy="7.5" r="7.5" fill="#915395"></circle>
        <path d="M4 7.22222L6.72269 10L11.5 5.5" stroke="white" stroke-width="1.5"></path>
      </svg>
    </div>`;

    const childText = el.querySelector('.yotpo-review');
    if (childText) {
      // Create a temporary div to parse the HTML string into DOM elements
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = childHTML;
      // Append the first child (the actual element) to the target
      if (tempDiv.firstChild) {
        childText.appendChild(tempDiv.firstChild);
      }
    }
  }
}

// Optimized expandable content with better performance
function initOptimizedExpandableContent() {
  const toggleBtn = document.querySelector('.expandable-content__toggle');
  const expSection = document.querySelector('.expandable-content');
  
  if (!toggleBtn || !expSection) return;
  
  let expandableText = toggleBtn.querySelector('.expandable-content__toggle-text');
  const startDescr = document.getElementById('descriptionStart');

  toggleBtn.addEventListener('click', function() {
    if (expSection.getAttribute('aria-expanded') === 'true') {
      expSection.setAttribute('aria-expanded', 'false');
      expSection.style.maxHeight = '350px';
      expandableText.innerHTML = expandableText.getAttribute('data-view-more');
      if (startDescr) {
        startDescr.scrollIntoView({behavior: 'smooth'}, true);
      }
    } else {
      expSection.setAttribute('aria-expanded', 'true');
      expSection.style.maxHeight = 'fit-content';
      expSection.style.paddingBottom = '50px';
      expandableText.innerHTML = expandableText.getAttribute('data-view-less');
    }
  });
}

// Optimized read more blocks
function initOptimizedReadMoreBlocks() {
  const moreBlocks = document.getElementById('readMoreBtn');
  if (!moreBlocks) return;

  // Query at init time only to decide whether to attach the listener at all.
  // The actual DOM queries run inside the click handler so they are never stale.
  const hasHidden =
    document.querySelector('.hideBlock') !== null ||
    document.querySelector('.hide_mob_Block') !== null;

  if (!hasHidden) return;

  moreBlocks.addEventListener('click', function(e) {
    e.preventDefault();
    // Re-query at click time to capture the current live DOM state.
    document.querySelectorAll('.hideBlock').forEach(function(block) {
      block.classList.remove('hideBlock');
      block.classList.add('showBlock');
    });
    document.querySelectorAll('.hide_mob_Block').forEach(function(block) {
      block.classList.remove('hide_mob_Block');
      block.classList.add('showBlock');
    });
    moreBlocks.style.display = 'none';
  });
}

// Initialize all optimizations when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Critical LCP optimization - run immediately
  optimizeSlideshowLCP();
  optimizeCollectionListLCP();
  
  // Use requestIdleCallback for non-critical initializations
  if (window.requestIdleCallback) {
    requestIdleCallback(() => {
      initOptimizedCheckoutCounter();
      initOptimizedYotpoReviews();
      initOptimizedExpandableContent();
      initOptimizedReadMoreBlocks();
    });
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(() => {
      initOptimizedCheckoutCounter();
      initOptimizedYotpoReviews();
      initOptimizedExpandableContent();
      initOptimizedReadMoreBlocks();
    }, 0);
  }
});
